module.exports = __webpack_public_path__ + "static/media/empty_order.419d2b63.png";